import { render, staticRenderFns } from "./MemoryQuestion.vue?vue&type=template&id=356778d2&scoped=true&"
import script from "./MemoryQuestion.vue?vue&type=script&lang=js&"
export * from "./MemoryQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MemoryQuestion.vue?vue&type=style&index=0&id=356778d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356778d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
